import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import '../../assets/css/playvideo.css';
import { t } from 'i18next';
const PlayVideo = () => {
  const location = useLocation();
  const { video, relatedVideos,runtime} = location.state || {};
  const navigate = useNavigate();
  const [currentVideo, setCurrentVideo] = useState(video);
  const [remainingVideos, setRemainingVideos] = useState(relatedVideos || []);

  const handlePlayAnotherVideo = (selectedVideo) => {
    setRemainingVideos((prevVideos) => [currentVideo, ...prevVideos.filter((v) => v !== selectedVideo)]);
    setCurrentVideo(selectedVideo);
  };

  const getAutoplayEmbedCode = (embedCode) => {
    if (!embedCode) return null;

    const parser = new DOMParser();
    const doc = parser.parseFromString(embedCode, 'text/html');
    const iframe = doc.querySelector('iframe');

    if (iframe) {
      const src = iframe.getAttribute('src');
      iframe.setAttribute('src', `${src}?autoplay=1`);
      return doc.body.innerHTML;
    }

    return embedCode;
  };
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  return (
    <>
      <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
      </div>


      <div className="col-md-12">
        {/* Main Video Section */}
        {currentVideo && (
          <>
            <h3 className="video-title">{currentVideo.name}</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: getAutoplayEmbedCode(currentVideo.embed?.['#cdata-section']),
              }}
              className="video-iframe"
            />
          </>
        )}
      </div>

      <div className="col-md-12 mt-5">
        {/* Recommended Videos Section */}
        {remainingVideos && remainingVideos.length > 0 && (
          <div className="play-video-wrapper">
            <h4 className="recommended-title">Recommended Videos</h4>
            {remainingVideos.map((relatedVideo, index) => (
              <div
                key={index}
                className="all-videos-list-item-wrapper"
                onClick={() => handlePlayAnotherVideo(relatedVideo)}
              >
                <div className="all-videos-list-item-thumb-wrapper">
                  <img
                    src={relatedVideo.image}
                    alt={relatedVideo.name} 
                    className="all-videos-list-item-thumbnail"
                  />
                  <div className="play-button">
                    <i className="bi bi-play-fill"></i>
                  </div>
                </div>
                <div className="all-videos-list-video-info-wrapper">
                  <h4 className="all-videos-list-video-title">{relatedVideo.name}</h4>
                  <span className="video-play-time-playvideo-page">{relatedVideo.runtime}</span>
                </div>

              </div>
            ))}
          </div>
        )}
      </div>
      </>
  );
};

export default PlayVideo;
